import React from "react";
import "./about.css";
import { ChartNoAxesCombined, PackageSearch } from "lucide-react";
import qfs from "./qfs.mp4";
const features = [
  {
    name: "Easy to work with",
    description:
      "QFS will consistently exceed customer expectation by providing value-adding banking solutions.",
    icon: ChartNoAxesCombined,
  },
  {
    name: "Offers",
    description:
      "QFS return outstanding value through our wide range of products and services.",
    icon: PackageSearch,
  },
];
const About = () => {
  return (
    <div className="about-section" id="about">
      <div className="about-wrapper">
      <div className="about-img-container">
          <video
            poster="https://www.japantimes.co.jp/uploads/imported_images/uploads/2021/02/np_file_65624.jpeg"
            src={qfs}
            width={2432}
            height={1442}
            controls
            data-aos="fade-up"
            className="about-img"
          />
        </div>
        <div className="why-choose-us-text-container about-text">
          <div className="header" data-aos="fade-up">
            <span className="header-line"></span>
            <h2>about us</h2>
          </div>
          <h1 data-aos="fade-up">
            learn more about Quantum Assests Global Ledger
          </h1>
          <p data-aos="fade-up">
            Little is it known that this new system has been designed in
            preparation for the takeover of the Central Bank Monetary Debt
            System to end the financial slavery and control over the populace.
            The Alliance gave President Trump the magic wand of taking over the
            old banking system without changing it. Humanity does not have the
            technology to fight the Deep State’s financial system.
            Extraterrestrials came to the rescue with alien or even
            other-dimensional technologies to accomplish this task. In Quantum
            Computers, intelligence is embedded without 3D proprieties. No 3D
            creation is able to replace the power of a living being. To this
            end, artificial intelligence (AI) was designed to replace conscious
            beings.
          </p>
          <dl className="mt-10 max-w-xl space-y-8 text-base/7 text-gray-600 lg:max-w-none">
            {features.map((feature) => (
              <div
                key={feature.name}
                data-aos="fade-up"
                className="relative pl-9"
              >
                 <dt className="inline font-semibold text-gray-900">
                  <div >
                    <feature.icon
                    height={24}
                    width={24}
                      aria-hidden="true"
                      className="absolute top-1 left-1 size-5 text-indigo-600"
                    />
                  
                  </div>

                  {feature.name}
                </dt>{" "}
                <dd>{feature.description}</dd>
              </div>
            ))}
          </dl>
          <a
            className="launch-btn launch"
            data-aos="fade-up"
            href="https://www.qfs1776.com/_files/ugd/a16bfe_46e53371c3924d10a587d58fb9e5a0e1.pdf"
          >
            <svg
              height="24"
              width="24"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M0 0h24v24H0z" fill="none"></path>
              <path
                d="M5 13c0-5.088 2.903-9.436 7-11.182C16.097 3.564 19 7.912 19 13c0 .823-.076 1.626-.22 2.403l1.94 1.832a.5.5 0 0 1 .095.603l-2.495 4.575a.5.5 0 0 1-.793.114l-2.234-2.234a1 1 0 0 0-.707-.293H9.414a1 1 0 0 0-.707.293l-2.234 2.234a.5.5 0 0 1-.793-.114l-2.495-4.575a.5.5 0 0 1 .095-.603l1.94-1.832C5.077 14.626 5 13.823 5 13zm1.476 6.696l.817-.817A3 3 0 0 1 9.414 18h5.172a3 3 0 0 1 2.121.879l.817.817.982-1.8-1.1-1.04a2 2 0 0 1-.593-1.82c.124-.664.187-1.345.187-2.036 0-3.87-1.995-7.3-5-8.96C8.995 5.7 7 9.13 7 13c0 .691.063 1.372.187 2.037a2 2 0 0 1-.593 1.82l-1.1 1.039.982 1.8zM12 13a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"
                fill="currentColor"
              ></path>
            </svg>
            <span> QUANTUM FINANCIAL SYSTEM manual</span>
          </a>
        </div>
        
      </div>
    </div>
  );
};

export default About;
